import { render } from "./ChatMessage.vue?vue&type=template&id=e5596e6e&scoped=true&lang=pug"
import script from "./ChatMessage.vue?vue&type=script&lang=js"
export * from "./ChatMessage.vue?vue&type=script&lang=js"

import "./ChatMessage.vue?vue&type=style&index=0&id=e5596e6e&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5596e6e"]])

export default __exports__